module.exports = __webpack_public_path__ + "static/img/zx.65e9a257.png";